import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
/** @jsx jsx */

import { memo } from 'react';
import { jsx } from '@emotion/core';
import { headingItemCSS } from '../internal/styles/menu-item/heading-item';
var HeadingItem =
/*#__PURE__*/
memo(function (_ref) {
  var children = _ref.children,
      testId = _ref.testId,
      id = _ref.id,
      _ref$cssFn = _ref.cssFn,
      cssFn = _ref$cssFn === void 0 ? function () {
    return {};
  } : _ref$cssFn,
      rest = _objectWithoutProperties(_ref, ["children", "testId", "id", "cssFn"]);

  return jsx("div", _extends({
    css: [headingItemCSS, cssFn(undefined)],
    "data-testid": testId,
    "data-ds--menu--heading-item": true,
    id: id
  }, rest), children);
});
export default HeadingItem;